import React, { useContext } from 'react';
import { AuthContext } from '../../../../../../contexts/AuthContext';
import { formatMoney } from '../../../../../../utils/utils';
import { momentParseDate } from '../../../../../../helpers';
import ButtonTableAction from '../../../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../../../components/default/DefaultDataTable';
import { WarehouseQuoteRate, WarehouseQuoteRateFilters } from '../../../../../../app/models/WareHouseQuoteRates';

interface Props {
  warehouseQuoteRates: WarehouseQuoteRate[];
  totalRows: number;
  isShow?: boolean;
  loading?: boolean;
  edit?: (id: number) => void;
  destroy?: (id: number) => void;
  show?: (id: number) => void;
  filter: WarehouseQuoteRateFilters;
  setFilter: (filter: WarehouseQuoteRateFilters) => void;
}

const WarehouseRatesDataTable = ({
  warehouseQuoteRates,
  totalRows,
  loading = false,
  isShow = false,
  edit,
  destroy,
  show,
  filter,
  setFilter
}: Props) => {
  const { auth } = useContext(AuthContext);

  const columns = [

    // {
    //     name: 'Id',
    //     selector: (row: any) => row?.id,
    //     sortable: true,
    //     sortField: 'id',
    //     width: 'auto',
    //     cell: (row: WarehouseQuoteRate, index: any, column: any) => (
    //         <span className="">{row?.id}</span>
    //     )
    // },
    
    
    {
        name: 'Almacén',
        selector: (row: any) => row.depot,
        sortable: true,
        sortField: 'depot',
        cell: (row: WarehouseQuoteRate, index: any, column: any) => (
            <span className="">
            <div
                dangerouslySetInnerHTML={{
                    __html: row.depot ? String(row.depot) : ''
                }}
            />
        </span>

        )
    },

        {
        name: 'Producto',
        selector: (row: any) => row.depot,
        sortable: true,
        sortField: 'product',
        cell: (row: WarehouseQuoteRate, index: any, column: any) => (
            <span className="">
            <div
                dangerouslySetInnerHTML={{
                    __html: row.product ? String(row.product) : ''
                }}
            />
        </span>

        )
    },
    {
      name: 'Precio unitario Ingreso',
      selector: (row: WarehouseQuoteRate) => row.container_entry_fee,
      sortable: true,
      sortField: 'container_entry_fee',
      cell: (row: WarehouseQuoteRate) => (
        <span>
          {formatMoney(row.container_entry_fee)} {row.container_entry_fee_currency} / {row.container_entry_fee_unit}
        </span>
      )
    },
    {
      name: 'Precio unitario Almacenaje día',
      selector: (row: WarehouseQuoteRate) => row.daily_storage_fee,
      sortable: true,
      sortField: 'daily_storage_fee',
      cell: (row: WarehouseQuoteRate) => (
        <span>
          {formatMoney(row.daily_storage_fee)} {row.daily_storage_fee_currency} / {row.daily_storage_fee_unit}
        </span>
      )
    },
    {
      name: 'Precio unitario Salida',
      selector: (row: WarehouseQuoteRate) => row.container_exit_fee,
      sortable: true,
      sortField: 'container_exit_fee',
      cell: (row: WarehouseQuoteRate) => (
        <span>
          {formatMoney(row.container_exit_fee)} {row.container_exit_fee_currency} / {row.container_exit_fee_unit}
        </span>
      )
    },

    {
      name: 'Acciones',
      cell: (row: WarehouseQuoteRate) => (
        <div className="d-flex gap-1">
          {show && (
            <ButtonTableAction
              callbackFunction={() => show(row.id!)}
              classIcon="mdi mdi-eye"
              colorIcon="text-info"
              title="Ver"
            />
          )}
          {!isShow && edit && (
              <ButtonTableAction
              callbackFunction={() => edit(row.id ?? -1)}
              classIcon="mdi mdi-pencil"
              colorIcon="text-warning"
              title="Editar"
              />
          )}
          {!isShow && destroy && (
              <ButtonTableAction
              callbackFunction={() => destroy(row.id ?? -1)}
              classIcon="mdi mdi-delete"
              colorIcon="text-danger"
              title="Eliminar"
              />
          )}
          </div>
      )
    }
  ];

  return (
    <div className="row">
      <div className="col-12 mt-4">
        <DefaultDataTable
          columns={columns}
          data={warehouseQuoteRates}
          progressPending={loading}
          filter={filter}
          setFilter={setFilter}
          paginationTotalRows={totalRows}
        />
      </div>
    </div>
  );
};

export default WarehouseRatesDataTable;
